import { render } from "./FormManterSecretaria.vue?vue&type=template&id=d835612e"
import script from "./FormManterSecretaria.vue?vue&type=script&lang=js"
export * from "./FormManterSecretaria.vue?vue&type=script&lang=js"

import "./FormManterSecretaria.vue?vue&type=style&index=0&id=d835612e&lang=css"
/* custom blocks */
import block0 from "./FormManterSecretaria.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__